<template>
  <!-- <Modal
    :lock-scroll="false"
    :mask-closable="false"
    :styles="{top: '40px'}"
    :title="`智能台账【${ledgerForm?.hlSerial}】`"
    @on-cancel="cancelLedger"
    class-name="hlModal"
    footer-hide
    v-model="showLedger"
  >-->
  <div v-if="consultantInfo?.consultationStatus != 'invalid_ledger'">
    <div class="hlContainer">
      <!-- <div
        class="leftWork"
        style="width: fit-content; max-width: 320px; min-width: 310px; max-width: 100%"
      >
        <slot name="extLeft"></slot>
        <div
          class="messageContianer selfPanel flex"
          v-if="currentId && ['INBOUND', 'OUTBOUND'].indexOf(ledgerForm?.callType )>= 0"
        >
          <div class="selfPanelTitle">
            <div>语音转译记录</div>
            <div class="rightBtns">
              <Tooltip content="刷新">
                <Icon @click="callConversationInfo" class="pointer" type="md-refresh" />
              </Tooltip>
            </div>
          </div>
          <div class="selfPanelContent">
            <GeminiScrollbar :autoshow="true">
              <div v-if="conversationInfos.length>0">
                <div
                  :class="['USER', 'customer'].indexOf(item.roleType) >= 0?'left conversationItem':'right conversationItem'"
                  :key="index + '-conversationItem'"
                  v-for="(item, index) in conversationInfos"
                >
                  <template v-if="['USER', 'customer'].indexOf(item.roleType) >= 0">
                    <h5 class="conversationItemRole">
                      <img
                        :src="require('@/assets/static/images/im/consultant@2x.png')"
                        class="personIcon"
                      />
                      <span>{{item.role}}</span>
                    </h5>
                  </template>
                  <template v-else>
                    <h5 class="conversationItemRole">
                      <span>{{item.role}}</span>
                      <img
                        :src="require('@/assets/static/images/im/lawyer@2x.png')"
                        class="personIcon"
                      />
                    </h5>
                  </template>
                  <div class="conversationItemContent">{{item.words}}</div>
                </div>
              </div>
              <div style="line-height: 4rem;margin-left:5vw;margin-top:2vh;" v-else>暂无语音转译记录</div>
              <a href="#scrollToMe" ref="scrollToMe"></a>
            </GeminiScrollbar>
            <Spin class="selfSpin" v-if="loadingConversation">
              <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
              <div>加载中，请稍候...</div>
            </Spin>
          </div>
        </div>
      </div>-->

      <div class="rightInfo" v-if="currentId">
        <div class="centerInfo">
          <div class="selfPanel" style="overflow: unset;">
            <div class="selfPanelTitle">
              <div class="toolBars">
                <div
                  :class="topToolType == 'detail'?'active toolBar':'toolBar'"
                  @click="changeTopTool('detail')"
                  class="toolBar"
                >{{['INBOUND', 'OUTBOUND'].indexOf(currentCallRecord?.callType )>= 0?'通话详情':'台账详情'}}</div>
                <div
                  :class="topToolType == 'callConversation'?'active toolBar':'toolBar'"
                  @click="changeTopTool('callConversation')"
                  class="toolBar"
                >语音转译记录</div>
              </div>
            </div>

            <div
              class="selfPanelContent"
              style="height: 270px; max-height: 280px; min-height: 270px"
            >
              <div style="height: 100%; overflow: hidden; display: flex; flex-direction: column;">
                <div style="flex-grow: 1;     overflow: hidden;">
                  <div
                    class="callRecordDetail"
                    style="overflow-y: auto"
                    v-if="topToolType == 'detail'"
                  >
                    <template v-if="ledgerForm.appId !='emergency'">
                      <template v-if="ledgerForm.icSubType == 'HL_MS'">
                        <table class="callRecordTable">
                          <tr>
                            <td>数据来源</td>
                            <td>{{getDataSourceName(currentCallRecord.dataSource)}}</td>
                            <td>状态</td>
                            <td>{{currentCallRecord.statusLabel}}</td>
                          </tr>
                          <tr>
                            <td>咨询时间</td>
                            <td>{{currentCallRecord.callTime}}</td>
                            <td>呼入号码</td>
                            <td>{{currentCallRecord.callPhone | desensitizedPhone}}</td>
                          </tr>
                          <tr>
                            <td>接通时间</td>
                            <td>{{currentCallRecord.putThroughTime}}</td>
                            <td>挂断时间</td>
                            <td>{{currentCallRecord.hangUpTime}}</td>
                          </tr>
                          <tr>
                            <td>服务律师</td>
                            <td>{{currentCallRecord.lawyerName}}</td>
                            <td>律师号码</td>
                            <td>{{currentCallRecord.lawyerPhone}}</td>
                          </tr>
                          <tr>
                            <td>等待时长（秒）</td>
                            <td>{{currentCallRecord.waitTime}}</td>
                            <td>通话时长（秒）</td>
                            <td>{{currentCallRecord.callDuration}}</td>
                          </tr>
                          <tr>
                            <td>是否已评价</td>
                            <td>{{currentCallRecord.satisfactionEvaluated?'是':'否'}}</td>
                            <td>满意度结果</td>
                            <td>{{currentCallRecord.satisfactionResultLabel}}</td>
                          </tr>
                          <!-- <tr v-if="fileUrl">
                        <td>录音文件</td>
                        <td colspan="3">
                          <audio
                            :controlslist="showControlslist"
                            controls
                            ref="audio"
                            style="padding: 8px; min-width: 100%;"
                            width="100%"
                          >
                            <source :src="fileUrl" />
                          </audio>
                        </td>
                          </tr>-->
                        </table>
                      </template>
                      <template v-else-if=" ledgerForm.icSubType =='HL_FP'">
                        <table
                          class="callRecordTable"
                          v-if=" ['INBOUND', 'OUTBOUND'].indexOf(currentCallRecord?.callType )>= 0"
                        >
                          <tr>
                            <td>呼叫类型</td>
                            <td>{{callTypes[currentCallRecord?.callType] || '--'}}</td>
                            <td>{{callTypes[currentCallRecord?.callType] || '开始'}}时间</td>
                            <td>{{currentCallRecord?.startTime}}</td>
                          </tr>
                          <tr>
                            <td>接听时间</td>
                            <td>{{currentCallRecord?.establishedTime || '--'}}</td>
                            <td>结束时间</td>
                            <td>{{currentCallRecord?.releaseTime || '--'}}</td>
                          </tr>
                          <tr>
                            <td>通话时长</td>
                            <td>{{currentCallRecord?.callDuration || '--'}}</td>
                            <td>挂断方</td>
                            <td>{{currentCallRecord?.releaseInitiator || '--'}}</td>
                          </tr>
                          <tr>
                            <td>主叫号码</td>
                            <td>{{currentCallRecord?.caller}}</td>
                            <td>主叫归属地</td>
                            <td>{{currentCallRecord?.callerLocation}}</td>
                          </tr>
                          <tr>
                            <td>被叫号码</td>
                            <td>{{currentCallRecord?.callee}}</td>
                            <td>被叫归属地</td>
                            <td>{{currentCallRecord?.calleeLocation}}</td>
                          </tr>
                          <tr v-if="currentCallRecord?.releaseTime">
                            <td>发送满意度调查</td>
                            <td>{{currentCallRecord?.satisfactionSurveyOffered?'是':'否'}}</td>
                            <td>满意度结果</td>
                            <td>{{satisfactionResultMap[currentCallRecord?.satisfaction]?.label}}</td>
                            <!-- <td>{{currentCallRecord?.satisfaction}}</td> -->
                          </tr>
                          <!-- <tr v-if="currentCallRecord?.releaseTime">
                  <td>挂断方</td>
                  <td>{{currentCallRecord?.releaseInitiator}}</td>
                  <td>挂断类型</td>
                  <td>{{$common.hangUpTypes[currentCallRecord?.hangUpType]}}</td>
                          </tr>-->
                          <!-- <tr v-if="fileUrl">
                        <td>录音文件</td>
                        <td colspan="3">
                          <audio
                            :controlslist="showControlslist"
                            controls
                            ref="audio"
                            style="padding: 8px; min-width: 100%;"
                            width="100%"
                          >
                            <source :src="fileUrl" />
                          </audio>
                        </td>
                          </tr>-->
                        </table>
                      </template>
                    </template>
                    <table class="callRecordTable" v-else>
                      <tr>
                        <td>台账类型</td>
                        <td>
                          <dicLabel
                            :value="ledgerForm?.callQueue"
                            category="CALL_QUEUE"
                            class="ledgerInfo"
                            defaultValue="--"
                          ></dicLabel>
                        </td>
                        <td>创建时间</td>
                        <td>{{ledgerForm?.callTime}}</td>
                      </tr>
                      <tr v-if="ledgerForm?.callType=='INBOUND'">
                        <td>主叫号码</td>
                        <td>{{ledgerForm?.phoneNumber | desensitizedPhone}}</td>
                        <td>主叫归属地</td>
                        <td>{{ledgerForm?.phoneLocation || '--'}}</td>
                      </tr>
                      <tr v-else-if="ledgerForm?.callType=='OUTBOUND'">
                        <td>呼出号码</td>
                        <td>{{ledgerForm?.phoneNumber | desensitizedPhone}}</td>
                        <td>呼出归属地</td>
                        <td>{{ledgerForm?.phoneLocation || '--'}}</td>
                      </tr>
                      <tr>
                        <td>开始时间</td>
                        <td>{{ledgerForm?.callTime || '--'}}</td>
                        <td>结束时间</td>
                        <td>{{ledgerForm?.finishTime || '--'}}</td>
                      </tr>
                      <!-- <tr v-if="fileUrl">
                    <td>录音文件</td>
                    <td colspan="3">
                      <audio
                        :controlslist="showControlslist"
                        controls
                        ref="audio"
                        style="padding: 8px; min-width: 100%;"
                        width="100%"
                      >
                        <source :src="fileUrl" />
                      </audio>
                    </td>
                      </tr>-->
                    </table>
                    <!-- <template v-if="fileUrl">
                  <Divider orientation="left">录音文件</Divider>
                  <audio
                    :controlslist="showControlslist"
                    controls
                    ref="audio"
                    style=" min-width: 100%;"
                    width="100%"
                  >
                    <source :src="fileUrl" />
                  </audio>
                    </template>-->
                  </div>
                  <div class="callConversationContianer" v-else>
                    <GeminiScrollbar :autoshow="true">
                      <div v-if="conversationInfos.length>0">
                        <div
                          :class="['USER', 'customer'].indexOf(item.roleType) >= 0?'left conversationItem':'right conversationItem'"
                          :key="index + '-conversationItem'"
                          v-for="(item, index) in conversationInfos"
                        >
                          <template v-if="['USER', 'customer'].indexOf(item.roleType) >= 0">
                            <h5 class="conversationItemRole">
                              <img
                                :src="require('@/assets/static/images/im/consultant@2x.png')"
                                class="personIcon"
                              />
                              <span>{{item.role}}</span>
                            </h5>
                          </template>
                          <template
                            v-else-if="['OPERATOR', 'operator'].indexOf(item.roleType) >= 0"
                          >
                            <h5 class="conversationItemRole">
                              <span>{{item.role}}</span>
                              <img
                                :src="require('@/assets/static/images/im/operator.png')"
                                class="personIcon"
                              />
                            </h5>
                          </template>
                          <template v-else>
                            <h5 class="conversationItemRole">
                              <span>{{item.role}}</span>
                              <img
                                :src="require('@/assets/static/images/im/lawyer@2x.png')"
                                class="personIcon"
                              />
                            </h5>
                          </template>
                          <div class="conversationItemContent">{{item.words}}</div>
                        </div>
                      </div>
                      <div
                        style="line-height: 4rem;text-align:center;margin-top:2vh;"
                        v-else
                      >暂无语音转译记录</div>
                      <a href="#scrollToMe" ref="scrollToMe"></a>
                    </GeminiScrollbar>
                    <Spin class="selfSpin" v-if="loadingConversation">
                      <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
                      <div>加载中，请稍候...</div>
                    </Spin>
                  </div>
                </div>
                <div v-if="fileUrl">
                  <!-- <td>录音文件</td>
                  <td colspan="3">-->
                  <audio
                    :controlslist="showControlslist"
                    controls
                    ref="audio"
                    style="padding: 8px; min-width: 100%;"
                    width="100%"
                  >
                    <source :src="fileUrl" />
                  </audio>
                  <!-- </td> -->
                </div>
              </div>
            </div>
          </div>
          <div
            class="selfPanel flex legderInfo"
            v-if="currentId && ['INBOUND', 'OUTBOUND'].indexOf(ledgerForm?.callType)  >= 0"
          >
            <div class="selfPanelTitle">
              <div>咨询内容</div>
              <div class="rightBtns" v-if="ledgerForm?.id">
                <Button
                  @click="uploadConsultant"
                  size="small"
                  type="primary"
                  v-if="currentPhone == undefined || currentPhone == null || currentPhone == ''"
                >录入咨询人信息</Button>

                <!-- <Button
                  @click="aiLedger"
                  size="small"
                  type="success"
                  v-if="hasAIRole && ledgerForm?.consultationStatus != 'finish'"
                >回拨</Button>-->

                <Button
                  @click="aiLedger"
                  size="small"
                  type="warning"
                  v-if="hasAIRole && ledgerForm?.consultationStatus != 'finish'"
                >AI台账</Button>

                <Button
                  @click="waitLedger"
                  size="small"
                  type="primary"
                  v-if="ledgerForm?.consultationStatus != 'finish'"
                >暂存</Button>
                <Button @click="saveLedger" size="small" type="error">保存</Button>
              </div>
            </div>
            <div class="selfPanelContent">
              <Form
                :label-width="100"
                :model="ledgerForm"
                :rules="ledgerFormValidate"
                ref="ledgerForm"
              >
                <Row>
                  <template
                    v-if="ledgerForm.mainBusinessTypeId && (ledgerForm.consultationType == undefined || ledgerForm.consultationType == null)"
                  >
                    <Col :xs="24">
                      <FormItem label="主业务类型" prop="mainBusinessTypeId">
                        <bussinessTypeTreeSelect
                          :multiple="false"
                          :value="ledgerForm.mainBusinessTypeId"
                          @change="changeMainBussinessTypeSet"
                          placeholder="请选择主业务类型"
                        />
                      </FormItem>
                    </Col>
                    <Col :xs="24">
                      <FormItem label="次业务类型">
                        <bussinessTypeTreeSelect
                          :multiple="true"
                          :values="ledgerForm.minorBusinessTypeIds"
                          @change="changeMinorBussinessTypeSet"
                          placeholder="请选择次业务类型"
                        />
                      </FormItem>
                    </Col>

                    <Col :sm="24" :xs="24">
                      <FormItem label="咨询标题" prop="subject">
                        <Input
                          clearable
                          placeholder="请输入咨询标题"
                          type="text"
                          v-model.trim="ledgerForm.subject"
                        ></Input>
                      </FormItem>
                    </Col>
                    <Col :sm="24" :xs="24">
                      <FormItem label="咨询归属地">
                        <Cascader
                          :data="regionData"
                          change-on-select
                          placeholder="请选择咨询归属地"
                          v-model.trim="ledgerForm.areaCodes"
                        ></Cascader>
                      </FormItem>
                    </Col>
                    <Col :sm="24" :xs="24">
                      <FormItem label="咨询内容" prop="clientDescription">
                        <Input
                          :autosize="{ minRows: 3, maxRows: 10 }"
                          maxlength="1000"
                          show-word-limit
                          type="textarea"
                          v-model.trim="ledgerForm.clientDescription"
                        ></Input>
                      </FormItem>
                    </Col>

                    <Col :sm="24" :xs="24">
                      <FormItem label="答复意见" prop="lawyerSuggestion">
                        <Input
                          :autosize="{ minRows: 3, maxRows: 10 }"
                          maxlength="1000"
                          show-word-limit
                          type="textarea"
                          v-model.trim="ledgerForm.lawyerSuggestion"
                        ></Input>
                      </FormItem>
                    </Col>

                    <Col :sm="12" :xs="24">
                      <FormItem label="事件标签">
                        <Select
                          clearable
                          filterable
                          placeholder="请选择事件标签"
                          v-model="ledgerForm.eventTag"
                        >
                          <Option
                            :key="item.val"
                            :value="item.val"
                            v-for="item in eventTags"
                          >{{ item.label }}</Option>
                        </Select>
                      </FormItem>
                    </Col>

                    <Col :sm="12" :xs="24">
                      <FormItem label="事发时间">
                        <Date-picker
                          @on-change="(val)=>{ledgerForm.sourceTime = val}"
                          format="yyyy-MM-dd HH:mm:ss"
                          placeholder="事发时间"
                          style="width: 100%"
                          type="datetime"
                          v-model="ledgerForm.sourceTime"
                        ></Date-picker>
                      </FormItem>
                    </Col>
                    <Col :sm="24" :xs="24">
                      <FormItem label="事发地点">
                        <Input
                          clearable
                          placeholder="请输入事发地点"
                          type="text"
                          v-model.trim="ledgerForm.sourceAddress"
                        ></Input>
                      </FormItem>
                    </Col>
                    <Col :sm="24" :xs="24">
                      <FormItem label="服务单号" prop="serviceNo">
                        <Input
                          clearable
                          placeholder="请输入服务单号"
                          type="text"
                          v-model.trim="ledgerForm.serviceNo"
                        ></Input>
                      </FormItem>
                    </Col>
                    <Col :sm="24" :xs="24">
                      <FormItem label="自定义标签" prop="tags">
                        <Select
                          @on-create="createTag"
                          allow-create
                          filterable
                          multiple
                          v-model="ledgerForm.tags"
                        >
                          <Option :key="item" :value="item" v-for="item in tagList">{{ item }}</Option>
                        </Select>
                      </FormItem>
                    </Col>
                  </template>
                  <template v-else>
                    <Col :xs="24">
                      <FormItem label="咨询类型" prop="consultationTypes">
                        <Cascader
                          :data="consultationTypeTree"
                          @on-change="changeConsultationTypes"
                          filterable
                          v-model="ledgerForm.consultationTypes"
                        ></Cascader>
                      </FormItem>
                    </Col>

                    <Col :xs="24">
                      <FormItem label="案由" prop="causeOfActions">
                        <div class="flex">
                          <Cascader
                            :data="causeTree"
                            @on-change="changeCauses"
                            filterable
                            v-model="ledgerForm.causeOfActions"
                          ></Cascader>
                          <FormItem
                            :label-width="0"
                            :rules="[{ required: true, message: '请输入案由备注', trigger: 'blur' }]"
                            label
                            prop="causeRemark"
                            v-if="needCauseRemark"
                          >
                            <Input
                              clearable
                              maxlength="200"
                              placeholder="请输入案由备注"
                              show-word-limit
                              type="text"
                              v-model="ledgerForm.causeRemark"
                            ></Input>
                          </FormItem>
                        </div>
                      </FormItem>
                    </Col>

                    <Col :lg="12" :xs="24">
                      <FormItem label="所属区域" prop="areaCodes">
                        <Cascader
                          :data="regionData"
                          change-on-select
                          filterable
                          placeholder="请选择所属区域"
                          v-model.trim="ledgerForm.areaCodes"
                        ></Cascader>
                      </FormItem>
                    </Col>

                    <Col :lg="12" :xs="24">
                      <FormItem label="处理方式" prop="handlingMethod">
                        <labelValue
                          :category="'HANDLING_METHOD'"
                          :data="ledgerForm.handlingMethod"
                          @change="(val) => {this.ledgerForm.handlingMethod = val}"
                        ></labelValue>
                      </FormItem>
                    </Col>

                    <Col :sm="24" :xs="24">
                      <FormItem
                        :rules="[{ required: true, message: '请填写咨询标题', trigger: 'blur' }]"
                        label="咨询标题"
                        prop="subject"
                      >
                        <Input
                          clearable
                          placeholder="请输入咨询标题"
                          type="text"
                          v-model.trim="ledgerForm.subject"
                        ></Input>
                      </FormItem>
                    </Col>

                    <Col :sm="24" :xs="24">
                      <FormItem label="咨询内容" prop="clientDescription">
                        <Input
                          :autosize="{ minRows: 3, maxRows: 10 }"
                          maxlength="1000"
                          show-word-limit
                          type="textarea"
                          v-model.trim="ledgerForm.clientDescription"
                        ></Input>
                      </FormItem>
                    </Col>

                    <Col :sm="24" :xs="24">
                      <FormItem label="答复意见" prop="lawyerSuggestion">
                        <Input
                          :autosize="{ minRows: 3, maxRows: 10 }"
                          maxlength="1000"
                          show-word-limit
                          type="textarea"
                          v-model.trim="ledgerForm.lawyerSuggestion"
                        ></Input>
                      </FormItem>
                    </Col>

                    <Col :sm="24" :xs="24">
                      <FormItem label="特殊情况备注" prop="remark">
                        <Input
                          :autosize="{ minRows: 3, maxRows: 10 }"
                          maxlength="255"
                          show-word-limit
                          type="textarea"
                          v-model.trim="ledgerForm.remark"
                        ></Input>
                      </FormItem>
                    </Col>
                  </template>
                </Row>
              </Form>
            </div>
          </div>
        </div>

        <div
          class="rightToolContianer"
          v-if="['INBOUND', 'OUTBOUND'].indexOf(ledgerForm?.callType)  >= 0"
        >
          <div class="selfPanel flex" style="height: 100%;">
            <div class="selfPanelTitle">
              <div class="toolBars">
                <div
                  :class="toolType == 'ai'?'active toolBar':'toolBar'"
                  @click="changeTool('ai')"
                  class="toolBar"
                >智能推送</div>
                <div
                  :class="toolType == 'personInfo'?'active toolBar':'toolBar'"
                  @click="changeTool('personInfo')"
                  v-if="currentPhone"
                >咨询人画像</div>
              </div>
            </div>
            <div class="selfPanelContent toolBody">
              <template v-if="toolType == 'personInfo' ">
                <consultantPortrait :consultantInfo="consultantInfo" v-if="consultantInfo" />
                <Spin class="selfSpin" v-if="loadingPortrait">
                  <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
                  <div>加载中，请稍候...</div>
                </Spin>
              </template>
              <knowledgeSearchTool
                :keyWords="keywords"
                ref="knowledgeSearchTool"
                v-else-if="toolType == 'ai'"
              />
            </div>
          </div>
          <!-- <div class="selfPanel mt1">
            <div class="selfPanelTitle">风险管理</div>
            <div class="selfPanelContent"></div>
          </div>-->
        </div>
        <Spin fix v-if="loadingShow">
          <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
          <div>加载中，请稍候...</div>
        </Spin>
      </div>
    </div>
    <Spin fix v-if="spinShow">
      <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
      <div>操作中，请稍候...</div>
    </Spin>

    <Modal
      :lock-scroll="false"
      :mask-closable="false"
      @on-cancel="cancelConsultantForm"
      class-name="hlModal"
      title="录入咨询人号码"
      v-model="showConsultantForm"
    >
      <div>
        <Form
          :label-width="100"
          :model="consultantUploadForm"
          :rules="formValidate"
          ref="consultantUploadForm"
        >
          <FormItem label="联系方式" prop="telPhone">
            <Input
              autocomplete="off"
              placeholder="请输入咨询人联系方式"
              type="text"
              v-model="consultantUploadForm.telPhone"
            ></Input>
          </FormItem>

          <FormItem label="姓名" prop="name">
            <Input
              autocomplete="off"
              placeholder="请输入咨询人姓名"
              type="text"
              v-model="consultantUploadForm.name"
            ></Input>
          </FormItem>
        </Form>
      </div>
      <template slot="footer">
        <Button @click="cancelConsultantForm" type="default">取消</Button>
        <Button @click="saveConsultantForm" type="primary">确定</Button>
      </template>
    </Modal>
  </div>
  <!-- </Modal> -->
</template>
<script>
export default {
  name: 'hldetail',
  props: {
    currentId: {
      required: false,
      type: Number,
      default: function () {
        return null
      }
    },
    // show: {
    //   required: false,
    //   default: false
    // },
    edit: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      callTypes: {},
      satisfactionResultOptions: [],
      satisfactionResultMap: {},
      topToolType: 'detail',
      toolType: 'ai',
      statusCode: null,
      eventTags: [],
      loadingShow: false,
      spinShow: false,
      showPanel: false,
      activeConfig: {},
      ledgerForm: {
        category: null,
        id: null,
        hlSerial: null,
        projectId: null,
        consultantNumber: null,
        icType: null,
        icSubType: null,
        consultationStatus: null,
        consultationTypes: [],
        consultationType: null,
        subConsultationType: null,
        causeOfActions: [],
        causeOfAction: null,
        areaCodes: [],
        provinceCode: null,
        cityCode: null,
        areaCode: null,
        handlingMethod: '',
        subject: '',
        clientDescription: '',
        lawyerSuggestion: '',
        remark: '',

        mainBusinessTypeId: null,
        minorBusinessTypeIds: null,
      },
      consultantInfo: null,
      currentCallRecord: null,
      currentUser: null,
      conversationInfos: [],
      keywords: [],
      loadingConversation: false,
      tagList: [],
      defaultTagList: [],
      callTypeOptions: [],
      ledgerFormValidate: {
        mainBusinessTypeId: [{ required: true, type: 'number', message: '请选择主业务类型', trigger: "change" }],


        consultationTypes: [{ required: true, type: 'array', message: '请选择咨询类型', trigger: "change" }],
        causeOfActions: [{ required: true, type: 'array', message: '请选择案由', trigger: "change" }],
        areaCodes: [{ required: true, type: 'array', message: '请选择所属区域', trigger: "change" }],
        handlingMethod: [{ required: true, message: '请选择处理方式', trigger: "change" }],
        // subject: [{ required: true, message: '请填写咨询标题', trigger: "blur" }],
        // mainBusinessTypeId: [{ required: true, type: 'number', message: '请选择主业务类型', trigger: "change" }],
        clientDescription: [{ required: true, message: '请输入客户自述内容', trigger: "blur" }],
        lawyerSuggestion: [{ required: true, message: '请输入处理意见', trigger: "blur" }],
        causeRemark: [{ required: true, message: '请输入案由备注', trigger: "blur" }],

        // leAges: [{ required: true, message: '请选择年龄段', trigger: "change" }],
        // leGender: [{ required: true, message: '请选择性别', trigger: "change" }],
        // leProfession: [{ required: true, message: '请选择职业', trigger: "change" }],
        // leConsultationType: [{ required: true, message: '请选择客户类别', trigger: "change" }],
        // leEducational: [{ required: true, message: '请选择学历', trigger: "change" }],
        // name: [{ required: true, message: '请填写咨询人姓名', trigger: 'blur' }],
      },
      timerMessage: null,
      loadingPortrait: false,
      currentPhone: null,
      showLedger: false,
      dataSources: [],
      fileUrl: null,
      regionData: [],
      showConsultantForm: false,
      consultantUploadForm: {
        telPhone: '',
        name: ''
      },
      formValidate: {
        telPhone: [{ required: true, message: '请输入咨询人联系方式', trigger: "blur" }],
      },
      consultationTypeTree: [],
      causeTree: [],
      needCauseRemark: false
    }
  },
  computed: {
    baseURL: function () {
      return this.$store.getters['systemSupport/systemSupport']?.HL || process.env.VUE_APP_API_ROOT
    },
    aiURL: function () {
      return this.$store.getters['systemSupport/systemSupport']?.AI || process.env.VUE_APP_API_ROOT
    },
    isAdmin: function () {
      return this.$store.getters['userInfo/isAdmin'] || false
    },
    systemRoles: function () {
      return (this.$store.getters['userInfo/user'] || {}).systemRoles || []
    },
    hasOperationRole: function () {
      return (this.systemRoles || []).indexOf('OPERATION_MANAGER') >= 0 || (this.systemRoles || []).indexOf('OPERATION') >= 0
    },
    showControlslist: function () {
      return (this.hasOperationRole || this.isAdmin) ? 'nofullscreen' : 'nodownload'
    },
    hasAIRole: function () {
      return (this.systemRoles || []).indexOf('AI_LEDGER') >= 0 || this.isAdmin
    },
  },
  watch: {
    edit: {
      immediate: true,
      deep: true,
      handler: function (val) {
        this.isEdit = val
      }
    },
    currentId: {
      immediate: true,
      deep: true,
      handler: function (val, old) {
        console.log(val, 'cId')
        if (val) {
          if (val != old) {
            this.ledgerForm = {
              id: null,
              category: null,
              hlSerial: null,
              consultationTypes: [],
              consultationType: null,
              subConsultationType: null,
              causeOfActions: [],
              causeOfAction: null,
              causeRemark: null,
              areaCodes: [],
              provinceCode: null,
              cityCode: null,
              areaCode: null,
              handlingMethod: '',
              subject: '',
              clientDescription: '',
              lawyerSuggestion: '',
              remark: '',
              mainBusinessTypeId: null,
              minorBusinessTypeIds: null,
            }
            this.currentCallRecord = {}
          }
          this.ledgerInfo()
        } else {
          this.ledgerForm = {
            id: null,
            category: null,
            hlSerial: null,
            consultationTypes: [],
            consultationType: null,
            subConsultationType: null,
            causeOfActions: [],
            causeOfAction: null,
            causeRemark: null,
            areaCodes: [],
            provinceCode: null,
            cityCode: null,
            areaCode: null,
            handlingMethod: '',
            subject: '',
            clientDescription: '',
            lawyerSuggestion: '',
            remark: '',
            mainBusinessTypeId: null,
            minorBusinessTypeIds: null,
          }
          this.currentCallRecord = {}
        }
      }
    }
  },
  methods: {
    initAreaTree: async function () {
      let that = this
      that.regionData = await this.$baseData.handleData(false, that.$apis.dictionaryManager.region.getLvTree, null) || []

      // this.$axios.post(that.$apis.dictionaryManager.region.getLvTree).then(res => {
      //   if (res.success) {
      //     that.regionData = res.result || []
      //   } else {
      //     that.$Message.error(res.message)
      //   }
      // }).catch(function (err) {
      //   that.$Message.error('区域数据获取失败！')
      // }).then(val => {
      // })
    },
    // getBasePath: async function (fileId) {
    //   console.log('this.fileId', fileId)
    //   if (fileId) {
    //     let params = new URLSearchParams()
    //     params.append("id", fileId)
    //     let data = await this.$axios.post(this.$apis.fileServerApi.getFileVisitedPath, params)
    //      = data.result
    //   }

    //   // return data.result
    // },
    changeConsultationTypes: function (value, selectedData) {
      console.log('changeConsultationTypes', value, selectedData)
      if (value && value.length > 1) {
        this.ledgerForm.consultationType = value[0]
        this.ledgerForm.subConsultationType = value[value.length - 1]
      } else {
        this.ledgerForm.consultationType = null
        this.ledgerForm.subConsultationType = null
      }
    },
    changeCauses: function (value, selectedData) {
      console.log('changeCauses', value, selectedData)
      if (value && value.length > 0) {
        this.ledgerForm.causeOfAction = value[value.length - 1]
        this.ledgerForm.causeRemark = null
        this.loadCauseData()
      } else {
        this.needCauseRemark = false
        this.ledgerForm.causeOfAction = null
        this.ledgerForm.causeRemark = null
      }
    },
    getDataSourceOptions: async function () {
      this.dataSources = await this.$baseData.handleData(false, this.$apis.projectManagementApi.getDataSourceOptions, null)
    },
    getDataSourceName: function (dataSource) {
      let da = this.dataSources.filter(item => item.code == dataSource)
      if (da.length > 0) {
        return da[0].remark
      } else {
        return ''
      }
    },
    cancelLedger: function () {
      this.ledgerForm = {}
      this.currentCallRecord = null
      this.consultantInfo = null
      this.tagList = this.defaultTagList
      this.$emit('cancelLedger')
    },
    hotlineList: function () {
      this.$emit('hotlineList')
    },
    ledgerInfo: function () {
      let that = this
      if (that.currentId == null || that.currentId == undefined) return
      this.loadingShow = true
      let params = new this.$URLSearchParams()
      that.showLedger = true
      // that.ledgerForm = {}
      that.currentCallRecord = {}
      that.fileUrl = null
      params.append("id", that.currentId)
      that.$axios.post(that.$apis.ICHLApi.hotlineApi.ledgerInfo, params).then(async res => {
        if (res.success) {
          // if (Object.keys(that.ledgerForm).length > 0) {
          //   // 补充信息
          //   let result = res.result?.ledger || {}
          //   that.ledgerForm.projectId = result.projectId
          //   that.ledgerForm.consultantNumber = result.consultantNumber
          //   that.ledgerForm.icType = result.icType
          //   that.ledgerForm.icSubType = result.icSubType
          //   that.ledgerForm.consultationStatus = result.consultationStatus
          //   that.ledgerForm.dataSource = result.dataSource
          //   that.ledgerForm.lawyerAccount = result.lawyerAccount
          //   that.ledgerForm.lawyerName = result.lawyerName
          //   that.ledgerForm.callTime = result.callTime
          //   that.ledgerForm.finishTime = result.finishTime
          //   that.ledgerForm.accessed = result.accessed
          //   that.ledgerForm.talkDuration = result.talkDuration
          //   that.ledgerForm.phoneNumber = result.phoneNumber
          //   that.ledgerForm.phoneLocation = result.phoneLocation
          //   that.ledgerForm.serviceNumber = result.serviceNumber
          //   that.ledgerForm.fileId = result.fileId
          //   that.ledgerForm.satisfaction = result.satisfaction
          //   that.ledgerForm.satisfactionSurveyOffered = result.satisfactionSurveyOffered
          //   that.ledgerForm.consultId = result.consultId
          // } else {
          //   that.ledgerForm = res.result?.ledger || {}
          // }
          that.ledgerForm = res.result?.ledger || {}
          that.loadCauseData()

          if (that.ledgerForm.fileId) {
            that.fileUrl = await that.getBasePath(that.ledgerForm.fileId)
          }
          that.currentCallRecord = res.result?.hlRecord || {}
          // that.loadHLRecord()
          that.toolType = 'ai'
          that.currentPhone = that.ledgerForm.consultantNumber
          if (that.currentPhone) {
            that.toolType = 'personInfo'
            that.getPortrait(that.currentPhone)
          } else {
            // that.toolType = 'ai'
          }
        } else {
          that.$Message.error({
            content: res.message || '获取台账记录失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('ledgerInfo error', err)
        that.$Message.error({
          content: '获取台账记录失败！',
          duration: 3
        })
      }).finally(() => {
        that.callConversationInfo()
        that.loadingShow = false
      })
    },
    changeTopTool: function (val) {
      if (this.topToolType != val) {
        this.topToolType = val
        switch (this.toolType) {

          case 'callConversation':
            this.callConversationInfo()
        }
      }
    },
    changeTool: function (value) {
      if (this.toolType != value) {
        this.toolType = value
        switch (this.toolType) {
          case 'personInfo':
            if (this.currentPhone) {
              this.getPortrait(this.currentPhone)
            }
            break
        }
      }
    },
    createTag: function (value) {
      let that = this
      this.$axios.post(this.$apis.ICHLApi.tag.saveOrUpdate, { name: value }).then(res => {
        if (res.success) {
          that.$Message.success("添加标签成功！")
          that.tagList.push(value)
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("添加标签成功！")
      })
    },
    scrollToDom (el) {
      this.$nextTick(() => { // 等待 DOM 渲染完成
        if (el) { // 如果元素存在，则滚动到目标位置
          el.scrollIntoView({ block: 'end', behavior: 'smooth' })
        }
      })
    },

    getPortrait: function (telePhone) {
      let that = this
      that.consultantInfo = null
      that.loadingPortrait = true
      let params = new this.$URLSearchParams()
      params.append("telPhone", telePhone)
      that.$axios.post(that.$apis.consultantManager.portrait.getPortrait, params).then(res => {
        if (res.success) {
          that.consultantInfo = res.result || {}
        } else {
          that.$Message.error({
            content: res.message || '获取咨询人画像！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('getPortrait error', err)
        that.$Message.error({
          content: '获取咨询人画像',
          duration: 3
        })
      }).finally(() => {
        setTimeout(() => {
          that.loadingPortrait = false
        }, 500)
      })
    },
    /**
     * 获取话务文本
     */
    callConversationInfo: function () {
      let that = this
      if (that.currentId) {
        this.loadingConversation = true
        let params = new this.$URLSearchParams()
        params.append("ledgerId", that.currentId)
        that.$axios.post(that.$apis.ICHLApi.hotlineApi.ledgerConInfo, params).then(res => {
          if (res.success) {
            that.conversationInfos = res.result?.callConversationInfos || []
            that.keywords = res.result?.keywords || []
          } else {
            that.$Message.error({
              content: res.message || '获取通话文本内容失败！',
              duration: 3
            })
          }
        }).catch(function (err) {
          console.log('callConversationInfo error', err)
          that.$Message.error({
            content: '获取通话文本内容失败！',
            duration: 3
          })
        }).finally(() => {
          that.scrollToDom(that.$refs.scrollToMe)
          that.loadingConversation = false
        })
      }
    },
    initTagList: function () {
      let that = this
      this.tagList = []
      this.defaultTagList = []
      this.$axios.post(that.$apis.ICHLApi.tag.tagOptions).then(res => {
        if (res.success) {
          that.tagList = res.result || []
          that.defaultTagList = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("获取事件标签失败！")
      })
    },
    getCallTypeOptions: function () {
      let that = this
      this.callTypes = {}
      this.$axios.post(that.$apis.ICHLApi.hotlineApi.getCallTypeOptions).then(res => {
        if (res.success) {
          that.callTypeOptions = res.result || []
          that.callTypeOptions.forEach(item => {
            that.callTypes[item.value] = item.label
          })
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log(err)
        that.$Message.error("获取呼叫类型参数失败！")
      })
    },
    initBaseData: function () {
      this.eventTags = []
      this.getDic("EVENT_TAG").then(val => {
        this.eventTags = val
      })
      this.getCallTypeOptions()
      this.initTagList()
    },
    changeMainBussinessTypeSet: function (data) {
      console.log('changeMainBussinessTypeSet', data)
      if (data && data.id) {
        this.$set(this.ledgerForm, 'mainBusinessTypeId', data.id)
      } else {
        this.$delete(this.ledgerForm, 'mainBusinessTypeId')
      }
    },
    changeMinorBussinessTypeSet: function (data) {
      let ids = []
      data.forEach((item) => { ids.push(item['id']) })
      if (this.ledgerForm) this.$set(this.ledgerForm, 'minorBusinessTypeIds', ids)
    },

    //	录入咨询人信息
    uploadConsultant: function () {
      this.showConsultantForm = true
    },
    cancelConsultantForm: function () {
      this.consultantUploadForm = {
        telPhone: '',
        name: ''
      }
      this.$refs.consultantUploadForm.resetFields()
      this.showConsultantForm = false
    },
    saveConsultantForm: function () {
      let that = this
      this.$refs["consultantUploadForm"].validate(valid => {
        let params = {
          id: that.currentId,
          consultantNumber: that.consultantUploadForm.telPhone
        }
        if (that.consultantUploadForm.name) params.consultantName = that.consultantUploadForm.name
        this.$Spin.show({
          render: (h) => {
            return h('div', [
              h('Icon', {
                'class': 'demo-spin-icon-load',
                props: {
                  type: 'ios-loading',
                  size: 18
                }
              }),
              h('div', '正在录入信息，请稍候...')
            ])
          }
        })
        this.$axios.post(that.$apis.ICHLApi.hotlineApi.uploadConsultantInfo, params).then(res => {
          if (res.success) {
            this.currentPhone = that.consultantUploadForm.telPhone
            that.ledgerForm.consultantNumber = that.consultantUploadForm.telPhone
            that.changeTool('personInfo')
            that.cancelConsultantForm()
          } else {
            that.$Message.error(res.message)
          }
        }).catch(function (err) {
          console.log('uploadConsultantInfo error', err)
          that.$Message.error('咨询人录入失败！')
        }).finally(() => {
          that.$Spin.hide()
        })
      })
    },
    aiFullInfo: async function (ledgerId, fileId) {
      //分析录音生成台账信息
      let that = this
      this.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', '正在为您生成智能台账信息，请稍候...')
          ])
        }
      })
      let file = await that.getBasePath(fileId, 30)
      console.log("url", file)
      let params = {
        filePath: file,
        ledgerId: ledgerId
      }
      // new this.$URLSearchParams()
      // params.append('filePath', url)
      // params.append('ledgerId', ledgerId)
      this.$axios.post(that.$apis.aiApi.aiLeader.voiceInfo, params, { baseURL: this.aiURL }).then(res => {
        if (res.success) {
          let result = res.result || {}
          that.uplaodLeader(true, result, fileId)
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('aiLedger error', err)
        that.$Message.error('智能台账生成失败！')
      }).finally(() => {
        that.$Spin.hide()
        // let result = {
        //   "consultantName": '咨询人姓名',
        //   "genderLabel": "性别",
        //   "subject": "主题",
        //   "clientDescription": "客户自述",
        //   "lawyerSuggestion": "处理意见",
        //   "businessTypeLabel": "业务类型",
        //   "businessTypeCode": "001005001002",
        //   "chats": [{
        //     "role": "律师",
        //     "content": "10jj为您服务，你好，请问什么好问一下咨询啊。"
        //   }, {
        //     "role": "咨询人",
        //     "content": "你好，我这个是启东市东海启东市东海镇宜翔镇的，现在是什么情况啊？咱们这个阳山这这小小农农民集安安置农民集中安置点呢，是三楼的，欧客店的。他们现在在那个楼顶上装光伏的装光伏的区，因为我们不同意，他现在是整体安装，我要咨询啊。"
        //   }, {
        //     "role": "律师",
        //     "content": "这个你这是在老板的房子上面安装，还是在四楼房子安装，在工厂里面装老板的他老板他老板都会建的。"
        //   }, {
        //     "role": "咨询人",
        //     "content": "这个房子安装的3个3个人和我建的房子有两个人一个同意，其中有一个应该都不在意。我觉得这是谁公共财产？因为一个不同意，他是建不了。"
        //   }, {
        //     "role": "律师",
        //     "content": "对呀，他现在就是还没认识的，还很认识的这个农民年检吧。没有啊，这个什么问题没有，房产证也没办法维权。他反正起诉法院不受理，好像必须要用这个房子，名件能能够证明你产生完全联系呢。就是那个起诉的话嗯，这个证明有权利才行，还有保护的是有权利的。你这个房子有个人自己管护的，他他是小小孩子也可以房屋的产权人，咱们没有什么权利做好的，没有想要的话就再回去了。"
        //   }]
        // }
        // that.uplaodLeader(result, fileId)
        // that.saveCallConversationInfos(result, fileId)
      })
    },
    uplaodLeader: function (reloadCon, result, fileId) {
      let that = this
      // that.spinShow = true
      let params = {
        id: this.currentId
      }

      if (result.provinceCode) {
        params.provinceCode = result.provinceCode
      }


      if (result.cityCode) {
        params.cityCode = result.cityCode
      }


      if (result.areaCode) {
        params.areaCode = result.areaCode
      }

      if (result.consultationType) {
        params.consultationType = result.consultationType
      }
      if (result.subConsultationType) {
        params.subConsultationType = result.subConsultationType
      }

      if (result.consultationTypes) {
        params.consultationTypes = result.consultationTypes
      }

      if (result.causeOfActions) {
        params.causeOfActions = result.causeOfActions
      }

      if (result.causeRemark) {
        params.causeRemark = result.causeRemark
      }

      if (result.causeOfAction) {
        params.causeOfAction = result.causeOfAction
      }

      if (result.handlingMethod) {
        params.handlingMethod = result.handlingMethod
      }

      if (result.remark) {
        params.remark = result.remark
      }


      if (result.subject) {
        params.subject = result.subject
      }

      if (result.lawyerSuggestion) {
        params.lawyerSuggestion = result.lawyerSuggestion
      }

      if (result.clientDescription) {
        params.clientDescription = result.clientDescription
      }

      if (result.businessTypeCode) {
        params.businessTypeCode = result.businessTypeCode
      }

      if (result.consultantNumber) {
        params.consultantNumber = result.consultantNumber
      }

      if (result.consultantName) {
        params.consultantName = result.consultantName
      }

      if (result.genderLabel) {
        params.genderLabel = result.genderLabel
      }

      if (result.educationalLabel) {
        params.educationalLabel = result.educationalLabel
      }
      if (result.professionCode) {
        params.professionCode = result.professionCode
      }
      if (result.agesCode) {
        params.agesCode = result.agesCode
      }
      if (result.industryCode) {
        params.industryCode = result.industryCode
      }
      if (result.educationalCode) {
        params.educationalCode = result.educationalCode
      }
      if (result.consultationTypeCode) {
        params.consultationTypeCode = result.consultationTypeCode
      }



      if (reloadCon) {
        if (result.keywords) {
          params.keywords = result.keywords
        }
        if (result.chats && result.chats.length > 0) {
          params.conversationInfos = (result.chats || []).map(item => {
            return {
              fileId: fileId,
              role: item.role,
              roleType: item.role == "律师" ? "LAWYER" : "USER",
              words: item.words
            }
          })
        }
      }
      this.$axios.post(this.$apis.ICHLApi.hotlineApi.uploadAIInfo, params).then(res => {
        if (res.success) {
          that.$Message.success("智能台账生成成功！")
          that.ledgerForm = res.result || {}
          if (reloadCon) that.callConversationInfo()
          that.loadCauseData()
          that.currentPhone = that.ledgerForm.consultantNumber
          if (that.currentPhone) that.getPortrait(that.currentPhone)
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('uplaodLeader error', err)
        that.$Message.error("操作失败！")
      }).finally(() => {
        // that.spinShow = false
      })
    },
    /**
     * 转存语音转文字
     */
    saveCallConversationInfos: function (result, fileId) {
      let that = this
      if (result.chats && result.chats.length > 0) {
        let params = {}
        params.id = this.currentId
        if (result.keywords) {
          params.keywords = result.keywords
        }
        params.conversationInfos = (result.chats || []).map(item => {
          return {
            fileId: fileId,
            role: item.role,
            roleType: item.role == "律师" ? "LAWYER" : "USER",
            words: item.content
          }
        })
        this.$axios.post(that.$apis.ICHLApi.hotlineApi.saveCallConversationInfos, params).then(res => {
          if (res.success) {
            that.callConversationInfo()
          } else {
            that.$Message.error(res.message)
          }
        }).catch(function (err) {
          console.log("saveCallConversationInfos error", err)
          that.$Message.error("保存语音转文字失败！")
        })
      }
    },
    ledgerPreFill: function () {
      let that = this
      this.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', '正在为您生成智能台账信息，请稍候...')
          ])
        }
      })
      let params = {}
      params.chatInfos = JSON.stringify(this.conversationInfos.map(item => {
        return {
          role: item.role,
          content: item.words
        }
      }))

      this.$axios.post(that.$apis.aiApi.aiLeader.ledgerPreFill, params, { baseURL: this.aiURL }).then(res => {
        if (res.success) {
          let result = res.result || {}
          that.uplaodLeader(false, result, null)
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('aiLedger error', err)
        that.$Message.error('操作失败！')

      }).finally(() => {
        that.$Spin.hide()
      })
    },
    getBasePath: async function (fileId, expiration) {
      console.log('this.fileId', fileId)
      let params = new this.$URLSearchParams()
      params.append("id", fileId)
      if (expiration) params.append("expiration", expiration)
      let data = await this.$axios.post(this.$apis.fileServerApi.getFileVisitedPath, params)
      // this.fileUrl = data.result
      return data.result
    },
    // AI台账
    aiLedger: function () {
      //生成台账信息
      if (this.conversationInfos.length > 0) {
        //根据咨询内容获取台账
        this.ledgerPreFill()
      } else {
        if (this.ledgerForm.fileId) {
          this.aiFullInfo(this.ledgerId, this.ledgerForm.fileId)
        } else {
          this.$Message.warning('不存在语音文件，智能台账生成失败！')
        }
      }
    },
    //暂存
    waitLedger: function () {
      let that = this
      this.spinShow = true
      this.ledgerForm.status = 'wait'
      if (this.ledgerForm.sourceTime) {
        this.ledgerForm.sourceTime = this.$moment(this.ledgerForm.sourceTime).format("YYYY-MM-DD HH:mm:ss")
      }
      if (this.ledgerForm.areaCodes && this.ledgerForm.areaCodes.length > 0) {
        this.ledgerForm.provinceCode = this.ledgerForm.areaCodes[0]
        this.ledgerForm.cityCode = this.ledgerForm.areaCodes.length > 1 ? this.ledgerForm.areaCodes[1] : null
        this.ledgerForm.areaCode = this.ledgerForm.areaCodes.length > 2 ? this.ledgerForm.areaCodes[2] : null
      } else {
        this.ledgerForm.provinceCode = null
        this.ledgerForm.cityCode = null
        this.ledgerForm.areaCode = null
      }
      this.$axios.post(this.$apis.ICHLApi.hotlineApi.saveOrUpdate, that.ledgerForm).then(res => {
        if (res.success) {
          that.$Message.success("暂存成功！")
          that.ledgerInfo()
          // that.hotlineList()
          // that.cancelLedger()
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('waitLedger error', waitLedger)
        that.$Message.error("操作失败！")
      }).finally(() => {
        that.spinShow = false
      })
    },

    //保存台账
    saveLedger: function () {
      let that = this
      this.spinShow = true
      this.ledgerForm.status = 'finish'
      this.$refs["ledgerForm"].validate(valid => {
        if (valid) {
          if (this.ledgerForm.sourceTime) {
            this.ledgerForm.sourceTime = this.$moment(this.ledgerForm.sourceTime).format("YYYY-MM-DD HH:mm:ss")
          }
          if (this.ledgerForm.areaCodes && this.ledgerForm.areaCodes.length > 0) {
            this.ledgerForm.provinceCode = this.ledgerForm.areaCodes[0]
            this.ledgerForm.cityCode = this.ledgerForm.areaCodes.length > 1 ? this.ledgerForm.areaCodes[1] : null
            this.ledgerForm.areaCode = this.ledgerForm.areaCodes.length > 2 ? this.ledgerForm.areaCodes[2] : null
          } else {
            this.ledgerForm.provinceCode = null
            this.ledgerForm.cityCode = null
            this.ledgerForm.areaCode = null
          }
          that.$axios.post(this.$apis.ICHLApi.hotlineApi.saveOrUpdate, that.ledgerForm).then(res => {
            if (res.success) {
              that.$Message.success("保存成功！")
              that.ledgerInfo()
              // that.hotlineList()
              // that.cancelLedger()
            } else {
              that.$Message.error(res.message)
            }
          }).catch(function (err) {
            console.log('saveLedger error', waitLedger)
            that.$Message.error("操作失败！")
          }).finally(() => {
            that.spinShow = false
          })
        } else {
          that.spinShow = false
          return false
        }
      })

    },
    loadSatisfactionResults: async function () {
      this.satisfactionResultOptions = await this.$baseData.handleData(false, this.$apis.common.satisfactionResultOptions, null) || []
      this.satisfactionResultOptions.forEach(item => {
        this.satisfactionResultMap[item.code] = item
      })
    },
    reloadData: function () {
      console.log('reloadData', this.currentId)
      this.ledgerInfo()
    },
    show: function () {
      console.log('show', this.currentId)
      this.ledgerInfo()
    },
    hide: function () {
      console.log('hide', this.currentId)
    },
    initConsultationType: async function () {
      let that = this
      this.consultationTypeTree = []
      let params = new this.$URLSearchParams()
      // params.append("includeEffc", true)

      this.consultationTypeTree = await this.$baseData.handleData(false, that.$apis.ICHLApi.ledgerDictionaryApi.allConsultationTypeTree, params) || []

      // this.$axios.post(that.$apis.ICHLApi.ledgerDictionaryApi.allConsultationTypeTree, params).then(res => {
      //   if (res.success) {
      //     that.consultationTypeTree = res.result || []
      //   } else {
      //     that.$Message.error(res.message)
      //   }
      // }).catch(function (err) {
      //   that.$Message.error("获取咨询类型失败！")
      // })
    },
    initCauseTree: async function () {
      let that = this
      this.causeTree = []
      let params = new this.$URLSearchParams()
      // params.append("includeEffc", true)
      this.causeTree = await this.$baseData.handleData(false, that.$apis.ICHLApi.ledgerDictionaryApi.allCauseTree, params) || []

      // this.$axios.post(that.$apis.ICHLApi.ledgerDictionaryApi.allCauseTree, params).then(res => {
      //   if (res.success) {
      //     that.causeTree = res.result || []
      //   } else {
      //     that.$Message.error(res.message)
      //   }
      // }).catch(function (err) {
      //   that.$Message.error("获取案由树失败！")
      // })
    },
    loadCauseData: async function () {
      let that = this
      let params = new this.$URLSearchParams()
      params.append("fullCode", this.ledgerForm.causeOfAction)
      that.needCauseRemark = false
      that.$axios.post(that.$apis.ICHLApi.ledgerDictionaryApi.causeData, params).then(res => {
        console.log("loadCauseData", res)
        if (res.success) {
          that.needCauseRemark = res.result?.needRemark || false
        }
      })

    },
  },
  beforeMount () {
    this.initCauseTree()
    this.initConsultationType()
    this.initAreaTree()
    this.getDataSourceOptions()
    this.loadSatisfactionResults()
    this.initBaseData()
  },
  destroyed () {
    this.currentCallRecord = null
    window.workbench = null
  }
}
</script>
<style lang="less" scoped>
.leftWork {
  > div:nth-child(2) {
    margin-top: 10px;
  }
}

.callConversationContianer {
  width: 100%;
  height: 100%;
  // max-height: 320px;
  // max-height: 270px;
}
</style>
